<script>
  // variant: info | warning | success | danger — tints the left border.
  let { children, title = null, variant = 'info' } = $props();
  const color = $derived({
    info: 'var(--accent)',
    warning: 'var(--warn)',
    success: 'var(--accent)',
    danger: 'var(--danger)',
  }[variant] ?? 'var(--accent)');
</script>

<div class="wf2-alert" style="border-left-color: {color}">
  {#if title}<h4 class="wf2-alert-title">{title}</h4>{/if}
  {#if children}{@render children()}{/if}
</div>
